'use client';

import React, { useEffect, useRef } from 'react';
import Link from 'next/link';

const rows = [
  { label: 'Monthly cost, fully loaded', inhouse: 'roughly $10,000', commandva: '$3,499', good: true },
  { label: 'Recruiting fees and hiring cycle', inhouse: 'Weeks to months, plus fees', commandva: 'None. Deployed in about 10 days', good: true },
  { label: 'Ramp period on your payroll', inhouse: '4 to 6 months', commandva: 'Pitch-trained before day one', good: true },
  { label: 'Turnover exposure', inhouse: '34 to 40% annually, $78K+ per departure', commandva: 'Career reps. Replacement is our cost, not yours', good: true },
  { label: 'Tools, data, and dialer', inhouse: 'You buy and manage the stack', commandva: 'Included', good: true },
  { label: 'Management overhead', inhouse: 'Roughly 5 hours per week', commandva: 'We manage, coach, and QA', good: true },
  { label: 'Commitment', inhouse: 'Employment', commandva: 'Month to month, 30 days notice', good: true },
];

export default function ComparisonTable() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const els = sectionRef?.current?.querySelectorAll('.rev');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-16 bg-white">
      <div className="max-w-site mx-auto px-7">
        <div className="rev mb-13 max-w-[780px]">
          <div className="eyebrow">Side by side</div>
          <h2 className="heading-2 text-ink">CommandVA against an in-house hire</h2>
        </div>

        <div className="rev overflow-x-auto" style={{ transitionDelay: '0.1s' }}>
          <table className="w-full border-collapse bg-white rounded-brand overflow-hidden border border-line-color text-[15px]">
            <thead>
              <tr>
                {['What it takes', 'In-house US SDR', 'CommandVA rep']?.map((h) => (
                  <th
                    key={h}
                    className="font-mono text-[11.5px] tracking-[0.14em] uppercase text-left px-5 py-4 bg-navy text-cream"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows?.map((row) => (
                <tr key={row?.label}>
                  <td className="px-5 py-4 border-t border-line-color font-semibold text-ink">
                    {row?.label}
                  </td>
                  <td className="px-5 py-4 border-t border-line-color text-muted-text">
                    {row?.inhouse}
                  </td>
                  <td className="px-5 py-4 border-t border-line-color font-semibold text-ink">
                    {row?.label === 'Monthly cost, fully loaded' ? (
                      <b className="text-primary">$3,499</b>
                    ) : (
                      row?.commandva
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="font-mono text-[12.5px] text-muted-text mt-3.5">
          Cost figures reflect published 2026 US market benchmarks for fully loaded SDR compensation and turnover. Full working shown on{' '}
          <Link href="/math" className="text-primary underline">The math</Link>.
        </p>
      </div>
    </section>
  );
}